import { useSelector } from "react-redux"
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import NavBar from "../components/navbar";
import Footer from "../components/footer";
import Contact from "../components/contact";
import { MetaTagHandler } from "../../../library/client/serverCallHandler";

const Commercial = () => {

    useEffect(() => {
        AOS.refresh();
    }, [])



    return (
        <>
            <MetaTagHandler>
                {() => (
                    <>
                        <title>Commercial & Industrial Drone Cleaning - Flyby Shine</title>
                        <meta name="description" content="Your local, community-based exterior cleaner. Turning commercial & industrial properties into neighborhood gems with advanced drone cleaning technology." />
                        <meta name="keywords" content="Drone Cleaning Service, Exterior Cleaner, Drone Soft Wash, Pressure Wash, Dumpster Pad Cleaning, Multi-Story Window Cleaning, Parking Lot Cleaning, Window Cleaning, Industrial Cleaning, Oil Terminal Tank Exterior Cleaning, Stadium and Dome Cleaning, Water Tower Cleaning" />
                        <meta property="og:image" content="/assets/commercial.png" />



                    </>
                )}
            </MetaTagHandler>
            <NavBar dark={true} />
            <div style={{
                height: '30vh',
                minHeight: '320px'
            }} className="core-header vivify fadeIn duration-300 delay-100 inline-header-core">
                <span>Our Services</span>
                <h1>Commercial & Industrial</h1>
                <p>Your local, community-based exterior cleaner. Turning commercial properties into neighborhood gems</p>
            </div>
            <div data-aos="fade-up" data-aos-delay="300">
                <div className="service-cards-list" style={{ marginTop: 75, justifyContent: 'center' }}>
                    <Link to="/data-center-cleaning" className="service-card">
                        <img src="/assets/datacenter.webp" alt="A drone cleaning a data center" />
                        <h2>Data Center Cleaning</h2>
                        <p>Keep your mission-critical facility running at peak efficiency with our specialized data center exterior cleaning services.</p>
                    </Link>
                    <Link to="/drone-softwash-pressurewash" className="service-card">
                        <img src="/assets/commercial.png" alt="A drone cleaning a commercial building" />

                        <h2>Drone Soft Wash/Pressure Wash</h2>
                        <p>Elevate Your Property's Appeal with Our Advanced Drone-Assisted Pressure and Soft Washing Services!</p>
                    </Link>
                    <Link to="/dumpster-pad-cleaning" className="service-card">
                        <img src="/assets/dumpster.jpg" alt="A drone cleaning a commercial building" />
                        <h2>
                            Dumpster Pad Cleaning</h2>
                        <p>
                            Our dumpster pad cleaning service is designed to keep your property looking clean and professional.
                        </p>
                    </Link>


                </div>
                <div className="service-cards-list" style={{ marginTop: 35, justifyContent: 'center' }}>
                    <Link to="/multi-story-window-cleaning" className="service-card">
                        <img src="/assets/multistorycropped.png" alt="A drone cleaning a highrise building" />
                        <h2>Multi-Story Window Cleaning</h2>
                        <p>Our innovative drone technology is redefining the landscape of exterior window cleaning</p>
                    </Link>
                    <Link to="/parking-lot-cleaning" className="service-card">
                        <img src="/assets/parkinglot.png" alt="A clean parking lot at sulivans grocery store" />
                        <h2>
                            Parking Lot Cleaning</h2>
                        <p>
                            Clean and maintain your parking lot with our personalized cleaning solutions.
                        </p>
                    </Link>
                    <Link to="/window-cleaning" className="service-card">

                        <img src="/assets/window.png" alt="A traditional window cleaning" />
                        <h2>
                            Window Cleaning</h2>
                        <p>
                            Whether it's drone assisted or traditional window cleaning, we have the tools and expertise to get the job done right.
                        </p>

                    </Link>


                </div>

                <div className="service-cards-list" style={{ marginTop: 35, justifyContent: 'center' }}>

                    <Link to="/oil-terminal-tank-exterior-cleaning" className="service-card">
                        <img src="/assets/oiltank.jpg" alt="A drone cleaning an oil terminal tank" />
                        <h2>Oil Terminal Tank Exterior Cleaning</h2>
                        <p>Our drones can reach high areas safely and efficiently, providing a thorough clean for oil terminal tanks.</p>
                    </Link>

                    <Link to="/stadium-and-dome-cleaning" className="service-card">
                        <img src="/assets/stadium2.jpg" alt="A drone cleaning a stadium" />
                        <h2>Stadium and Dome Cleaning</h2>
                        <p>Clean
                            large surface areas quickly and efficiently with our cutting-edge drone technology. </p>

                    </Link>


                    <Link to="/water-tower-cleaning" className="service-card" >
                        <img src="/assets/watertower.jpg" alt="A drone cleaning a water tower" />
                        <h2>Water Tower Cleaning</h2>
                        <p>Water towers are essential for your community. Keep them clean and well-maintained with our drone technology.
                        </p>
                    </Link>

                </div>
                <div className="service-cards-list" style={{ marginTop: 35, justifyContent: 'center' }}>
                    <Link to="/industrial-cleaning" className="service-card">
                        <img src="/assets/industrial.jpg" alt="A drone cleaning an industrial building" />
                        <h2>Industrial Cleaning</h2>
                        <p>Keep Your Property Safe and Hygienic with Our Expert Industrial Cleaning Services</p>
                    </Link>


                </div>
            </div>
            <Contact />

            <Footer />
            {/* <MetaTagHandler >
                {() => (
                    <>
                        <title>Poodle</title>
                    </>
                )}
            </MetaTagHandler>  */}
            {/* <NonLodable /> */}

            {/* <h2><ServerCallHandler id={"getDogHusky"} pathway={'getDog'} data={{breed:'husky'}} fetchHandler={'/api'} overwrite={'getDogHusky.src'} /></h2> */}



        </>
    )
}

export default Commercial